<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ack"><a id="page_7"></a><em>Acknowledgments</em></h2>
<p class="noindent"><strong>A</strong> very special thank you to my student/friend, who did not want her name to appear in the book: Thank you for the countless hours you put into editing the manuscript—your help was invaluable.</p>
<p class="indent">My deepest gratitude to my friend Sushila Oliphant for the diagrams and drawings: Your help and energy throughout the years has been much appreciated.<a id="page_8"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?8fd54f76